<template>
  <div class="public-content theme-management">
    <div class="region-title" style="background: #fff">主题管理</div>
    <div class="add-category" v-permission="'pms:admin:theme:add'">
      <el-button round type="primary" @click="title='添加主题',themeName = '',type='add',dialogVisible=true">添加</el-button>
    </div>
    <div class="data-list">
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border :row-class-name="rowClassName">
        <el-table-column width="200px" prop="id" label="编号"> </el-table-column>
        <el-table-column min-width="200px" prop="themeName" label="主题"></el-table-column>
        <el-table-column min-width="200px" label="操作">
          <template v-slot="scope">
            <span class="color-blue" v-permission="'pms:admin:theme:update'" @click="changeList('编辑', scope.row)">编辑<br></span>
            <span class="color-blue" v-permission="'pms:admin:theme:delete'" @click="deleteId=scope.row,deleteDialog=true">删除<br></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CombinedDialog ref="dialogRef" @addList="addCategory" @changeRemark="changeName" @delete="deleteTheme"></CombinedDialog>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 编辑/添加主题 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="dialogVisible" width="30%">
      <div style="width:60%;margin:0 auto">
        <span>主题：</span>
        <el-input style="width:200px" v-model="themeName" placeholder="请输入内容" maxlength="20"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTheme">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该主题？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="changeList('删除',deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import VPagination from '@/components/Pagination/index.vue'
import { sampleList, sampleAdd, sampleUpdate, sampleUsable, sampleDelete } from '@/api/pms'
export default {
  name: 'theme-management',
  components: {
    CombinedDialog,
    VPagination
  },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      title: '',
      choiceId: '',
      themeName: '',
      dialogVisible: false,
      tableData: [],
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    this.getTheme(this.queryInfo)
  },
  methods: {
    addTheme () {
      if (this.themeName === '') {
        this.$message.error('请输入名称')
        return
      }
      if (this.type === 'edit') {
        sampleUsable({ act: 1, spuDictName: this.themeName }).then(res => {
          if (res.data.success) {
            sampleUpdate({ themeId: this.choiceId, themeName: this.themeName }).then(res => {
              if (res.data.success) {
                this.getTheme(this.queryInfo)
                this.$message.success('修改成功')
                this.dialogVisible = false
              }
            })
          }
        })
      } else if (this.type === 'add') {
        sampleUsable({ act: 0, spuDictName: this.themeName }).then(res => {
          if (res.data.success) {
            sampleAdd(this.themeName).then(res => {
              if (res.data.success) {
                this.getTheme(this.queryInfo)
                this.$message.success('添加成功')
                this.dialogVisible = false
              }
            })
          }
        })
      }
    },
    getTheme (val) {
      sampleList({ pageNum: val.pageNum, pageSize: val.pageSize }).then((res) => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getTheme(this.queryInfo)
          }
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].operation = {
              edit: '编辑',
              delete: '删除'
            }
          }
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      // 把每一行的索引放进row
      row.index = rowIndex
      // this.tableData[rowIndex].index = rowIndex
    },
    changeList (val, content) {
      this.choiceId = content.id
      if (val === '删除') {
        sampleDelete(content.id).then(res => {
          if (res.data.success) {
            this.getTheme(this.queryInfo)
            this.$message.success('删除成功')
            this.deleteDialog = false
          }
        })
      }
      if (val === '编辑') {
        this.title = '编辑主题'
        this.type = 'edit'
        this.themeName = content.themeName
        this.dialogVisible = true
      }
    },
    primaryAdd () {
    },
    addCategory () {
      this.getTheme(this.queryInfo)
    },
    changeName () {
      this.getTheme(this.queryInfo)
    },
    changePage (val) {
      this.queryInfo = val
      this.getTheme(this.queryInfo)
    },
    deleteTheme () {
      this.getTheme(this.queryInfo)
    }
  }
}
</script>
 <style scoped lang="less">
@import "./styles";
@deep: ~">>>";
</style>
